import { useNavigate } from 'react-router';
import History from './history';

export const HistoryComponent = () => {
  History.navigate = useNavigate();
  return null;
};
